const updateDirectory = (state, action) => {
  if(state===undefined || action?.type==='RESET'){
    return {
      shorts: undefined,
      loaded:[],
    }
  }
  const { directory:data } = state;

  switch(action.type){
    case 'SET_DIRECTORY_SHORTS':
      return {...data, shorts: action.payload};
    case 'SET_DIRECTORY_LOADED':
      return {...data, loaded: action.payload};

    default:
      return data;
  }
}

export default updateDirectory;
